'use strict';
/**
 * Service: Fulfillment Groups
 *
 * @version
 * 12.10.0 MLIBJS-137 Add order and fulfillment group parsing for manufacturing format
 * 12.4.0 #756 MLIBJS-121 Add validation to export wdFulfillmentGroupService for ES6 usage
 * 12.1.0 #745 MLIBJS-113 Add method to wdFulfillmentGroupService to allow setting the fulfillment groups
 * 10.1.0 #710 MLIBJS-84 Refactor Fulfillment Group Parsed Response
 * 9.0.0 #701 MLIBJS-75 Remove deprecated services
 * 7.4.0 #470 Refactor changes to status and fulfilment group statuses
 * 7.3.0 #458 Refactor wdFulfillment, wdStatus (inject helpers)
 * 7.0.0 #433 Adapt Main Library for Custom Statuses
 * 5.8.0 #390 Add Individual Fabrication Time to parseFulfillmentGroups
 * 5.6.5 #368 Refactor wdFulfillmentGroups to accept label names for tracker items
 * 5.6.2 #361 Refactor wdOrder service to pass in order number
 * 5.6.0 #350 Fulfillment group service: include module
 * 5.0.1 #286 Standardise Data Loading and Parsing Services
 *
 * @author Dallas Vogels <dvogels@webduct.com>
 * @author Ryan Sweeney <rsweeney@webduct.com>
 * @author Deitric Jang <djang@webduct.com>
 * @author Jenny Lam <jlam@buildcentrix.com>
 * @author Erik Orozco <eorozco@intersog.com>
 *
 * @copyright (c) 2014-2021 Build Centrix
 */
var wdFulfillmentGroupService = angular.module('wd.service.fulfillment', [])
    .factory(
    'wdFulfillmentGroupService',
    [
        'wdOauth2HttpService', '$q', 'wdApiResponseHandler', 'wdSharedFunctionsService', 'wdFulfillmentGroupHelper',
        function (wdOauth2HttpService, $q, wdApiResponseHandler, wdSharedFunctionsService, wdFulfillmentGroupHelper)
        {
            // Initialize Service
            var service = {};

            //Clear Current Values
            service.fulfillmentGroups = [];

            // Variables
            var apiUrl;   // e.g. timecard-api, ordering-api

            /**
             * Get Fulfillment Groups
             *
             * @deprecated It is recommended to fetch the fulfillment groups with GraphQL instead of the rest api
             * @see https://webduct.atlassian.net/browse/TIMUI-241
             *
             * @since 5.0.1
             * @returns {Object}
             */
            service.getFulfillmentGroups = function () {

                var deferred = $q.defer();

                //Clear Current Values
                service.fulfillmentGroups = [];

                var url = apiUrl + 'orders/fulfillment/groups';

                wdOauth2HttpService.get(url)
                    .then(
                    function (response)
                    {
                        if (wdApiResponseHandler.isGoodResponseCode(response.status)) {

                            service.fulfillmentGroups = response.data ? service.parseFulfillmentGroups(response.data) : [];
                            deferred.resolve(response);

                        } else {

                            deferred.reject(response);

                        }

                    }, function (response)
                    {

                        deferred.reject(response);

                    }
                );

                return deferred.promise;
            };

            /**
             * Set fulfillment groups
             *
             * @since 12.1.0
             *
             * @param {Array} fulfillmentGroups
             * @returns {boolean}
             */
            service.setFulfillmentGroups = function (fulfillmentGroups) {

                if (fulfillmentGroups) {
                    service.fulfillmentGroups = service.parseFulfillmentGroups(fulfillmentGroups);
                } else {
                    service.fulfillmentGroups = [];
                }

                return true;
            };

            /**
             * Set Api Url
             *
             * @since 7.3.0
             *
             * @param {String} url
             * @returns {boolean}
             */
            service.setApiUrl = function (url)
            {
                apiUrl = url;
                return true;
            };

            /**
             * Parse Fulfilment Groups from an Order
             *
             * @since 5.0.1
             *
             * @params {Object} fulfillmentGroups A list of fulfillment groups for an order
             * @returns Array fgList
             */
            service.parseFulfillmentGroups = function(fulfillmentGroups) {
                return wdFulfillmentGroupHelper.parseFulfillmentGroups(fulfillmentGroups);
            };

            /**
             * Parse Fulfilment Groups from an Order (in manufacturing format)
             *
             * @since 12.10.0
             *
             * @params {Object} fulfillmentGroups A list of fulfillment groups for an order
             * @returns Array fgList
             */
            service.parseFulfillmentGroupsManufacturing = function(fulfillmentGroups) {
                return wdFulfillmentGroupHelper.parseFulfillmentGroupsManufacturing(fulfillmentGroups);
            };

            /**
             * Parse Fulfillment Group Items
             * @param {{}} items
             * @returns {Array}
             */
            service.parseFulfillmentGroupItems = function(items){
                return wdFulfillmentGroupHelper.parseFulfillmentGroupItems(items);
            };

            /**
             * Parse Dimensions for Table
             *
             * @since 1.1.0
             * @param {{}} dimensions
             * @returns {Array}
             */
            service.parseDimensions = function (dimensions) {
                return wdFulfillmentGroupHelper.parseDimensions(dimensions);
            };

            /**
             * Parse Joints for Table
             *
             * @since 1.1.0
             * @param {{}} joints
             * @returns {Array}
             */
            service.parseJoints = function (joints) {
                return wdFulfillmentGroupHelper.parseJoints(joints);
            };

            /**
             * Parse Materials for Table
             *
             * @since 1.1.0
             * @param {{}} materials
             * @returns {Array}
             */
            service.parseMaterials = function (materials) {
                return wdFulfillmentGroupHelper.parseMaterials(materials);
            };

            return service;
        }
    ]
);
if (typeof module !== 'undefined' && module.exports) {
    module.exports = wdFulfillmentGroupService;
}
// EOF
